// Escapa `</script>` para evitar quebra do bloco JSON-LD inline.
export const safeJsonLd = (obj) =>
  JSON.stringify(obj).replace(/</g, '\\u003c');
